import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import LazyImgixImage from '@components/LazyImgixImage';
import useEventTracking from '@hooks/useEventTracking';
import { subscribe_path } from '@routes';
import { IMGIX_URL } from '@src/env';
import { ClickTarget, TrackingLocation, click } from '@tracking';

const BestInTech = () => {
  const bestInTechHeader = `${IMGIX_URL}/global/subscribe/Best_Tech_News.png`;
  const { trackEvent } = useEventTracking({ location: TrackingLocation.BestInTech });

  return (
    <aside className="flex items-center md:gap-48 lg:px-16" data-test="best-in-tech">
      <LazyImgixImage
        alt="Best in Tech News Header"
        src={bestInTechHeader}
        sizes="600px"
        className="hidden w-[466px] md:block"
        wrapperClassName="!flex"
      />
      <div>
        <span className="font-suisse-intl-mono text-overline-md text-primary-magenta">
          Read the best in tech news
        </span>
        <h1 className="mb-16 mt-8 font-suisse-works text-headline-xs text-black md:mb-8 lg:text-headline-md">
          Know what matters—before everyone else finds out
        </h1>
        <LazyImgixImage
          alt="Best in Tech News Header"
          src={bestInTechHeader}
          sizes="600px"
          className="block w-full max-w-[466px] md:hidden"
          wrapperClassName="!flex justify-center"
        />
        <p className="mb-0 mt-16 text-paragraph font-light text-grayscale-charcoal md:mt-0">
          Get access to exclusive coverage and read deeply reported stories from the largest
          dedicated newsroom to tech journalism. Deep-dive into topics like venture capital,
          startups, crypto, the creator economy and more with our top reporters and other
          executives.
        </p>
        <PrimaryButton
          as="link"
          size="small"
          href={subscribe_path()}
          className="m-auto mt-16 w-full max-w-[311px] md:mt-24"
          onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.Subscribe }))}
        >
          Subscribe
        </PrimaryButton>
      </div>
    </aside>
  );
};

export default BestInTech;
